import React from 'react'
import { Button, Divider, Menu, MenuItem } from '@mui/material'
import { AccessLevel } from 'src/graphql.generated'
import { checkIfProductionEnvironment } from 'src/lib/checkIfProductionEnvironment'
import { useChangeAccessLevel } from 'src/session/useSessionQueries'
import { DeveloperRoleMenuItems } from '../currentRole'
import { onDark } from '../theme'

const navItemSx = {
  color: onDark.primary,
  textTransform: 'uppercase' as const,
  textDecoration: 'none',
  px: 1,
  borderRadius: 1,
  '&:hover': { textDecoration: 'none' },
}

const AdvancedDeveloperMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<Element | null>(null)
  const changeAccessLevel = useChangeAccessLevel()
  const handleClick = (event: React.MouseEvent) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Button onClick={handleClick} sx={navItemSx}>
        Developer
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => changeAccessLevel(AccessLevel.Coach)}>Switch to Coach</MenuItem>
        <MenuItem onClick={() => changeAccessLevel(AccessLevel.Manager)}>Switch to Manager</MenuItem>
        <MenuItem onClick={() => changeAccessLevel(AccessLevel.CareCoordinator)}>Switch to Care Coordinator</MenuItem>
        <MenuItem onClick={() => changeAccessLevel(AccessLevel.CommunityFacilitator)}>
          Switch to Community Facilitator
        </MenuItem>
        {!checkIfProductionEnvironment() && <Divider />}
        {!checkIfProductionEnvironment() && <DeveloperRoleMenuItems onSelect={handleClose} />}
      </Menu>
    </>
  )
}

export default AdvancedDeveloperMenu
